import { Link } from "react-router-dom";
import LegalLayout, { Section, Mail } from "@/pages/legal/LegalLayout";

export default function Terms() {
    return (
        <LegalLayout
            testId="terms-page"
            eyebrow="Legal"
            title="Terms of service"
            intro="These terms are the agreement between you and H. Tokoki LLC, which operates Day Dreamer. By creating an account or using Day Dreamer, you agree to them."
        >
            <Section title="Your account">
                <p>You must be at least 13 to use Day Dreamer, and old enough to form a binding contract where you live to make a purchase. Keep your sign-in details secure; you are responsible for activity on your account.</p>
            </Section>

            <Section title="Your writing is yours">
                <p>You keep all rights to what you write and upload. You give us a limited permission to store, process, and display it only to run Day Dreamer for you — including sending the parts an AI feature needs to the provider that powers it, as described in our <Link to="/privacy" className="text-primary underline underline-offset-2">privacy policy</Link>. That permission ends when your content is deleted.</p>
            </Section>

            <Section title="AI features">
                <p>AI suggestions can be wrong, repetitive, or unsuitable. Review anything AI produces before you rely on or publish it; you decide what goes into your work. To the extent we have any rights in the text AI features produce for you, we assign them to you.</p>
            </Section>

            <Section title="Acceptable use">
                <p>Don't use Day Dreamer to break the law, to infringe anyone else's rights, or to harass or harm anyone. Don't attempt to disrupt or gain unauthorised access to the service, scrape it, reverse-engineer it, or get around plan limits and AI allowances. We may suspend accounts that do.</p>
            </Section>

            <Section title="Plans and payment">
                <p>Current plans and prices are shown on the pricing page. Each paid plan includes a monthly AI word allowance; when an allowance runs out you can buy more words or wait for the next period.</p>
                <p><strong className="text-foreground">On the web,</strong> a plan is a one-time payment for 30 days or one year of access. It does not renew automatically — buy again when you want to continue.</p>
                <p><strong className="text-foreground">In the Android app,</strong> plans are subscriptions billed by Google Play. They renew until you cancel them in Google Play, and are governed by Google Play's terms.</p>
                <p>For a refund request, write to <Mail />. Purchases made through Google Play are refunded under Google Play's policies. Nothing in these terms limits any refund right you have under the law where you live.</p>
            </Section>

            <Section title="Ending your account">
                <p>You can delete your account at any time — see <Link to="/delete-account" className="text-primary underline underline-offset-2">how to delete your account</Link>. We may suspend or end an account that breaks these terms. Export your writing before deleting if you want to keep it.</p>
            </Section>

            <Section title="The service">
                <p>We work to keep Day Dreamer available and your writing safe, but we provide it as is, without warranties of any kind, to the extent the law allows. Keep your own copies of work that matters to you; export is available from the web app at any time.</p>
                <p>To the extent the law allows, H. Tokoki LLC is not liable for indirect or consequential losses, and our total liability for any claim is limited to the amount you paid us in the twelve months before it arose.</p>
            </Section>

            <Section title="Changes and governing law">
                <p>If we change these terms we will update the date above and tell you in the app before significant changes take effect. These terms are governed by the laws of the State of South Carolina, USA.</p>
            </Section>

            <Section title="Contact">
                <p><Mail /></p>
            </Section>
        </LegalLayout>
    );
}
